import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  selectBulkStats,
  selectIsDrawableBulkOperation,
  selectIsPatchableBulkOperation,
  selectSelectedBulkOperation,
  selectSelectedSurveys,
} from './bulk-edit.selectors';

@Injectable({ providedIn: 'root' })
export class BulkEditSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly selectedSurveys = this._store.selectSignal(
    selectSelectedSurveys,
  );

  public readonly selectedBulkOperation = this._store.selectSignal(
    selectSelectedBulkOperation,
  );

  public readonly isDrawableBulkOperation = this._store.selectSignal(
    selectIsDrawableBulkOperation,
  );

  public readonly isPatchableBulkOperation = this._store.selectSignal(
    selectIsPatchableBulkOperation,
  );

  public readonly bulkStats = this._store.selectSignal(selectBulkStats);
}
